/**
 * How much of a twin's final room answer rests on its own profile records.
 * Python owns the set (models.room_chat.AnswerGroundingLevel) and computes the
 * level; Nest passes it through into message metadata; the chat UI renders it.
 * Bound by tests/apps/python-api/test_closed_value_set_parity.py.
 */
export const ANSWER_GROUNDING_LEVELS = ['recorded', 'related', 'estimate', 'declined'] as const;
export type AnswerGroundingLevel = (typeof ANSWER_GROUNDING_LEVELS)[number];
